import { useQuery } from '@tanstack/react-query';

import { fetchAnalytics } from '@/api/me';
import type { AnalyticsRange } from '@/types/api';

export function useAnalytics(range: AnalyticsRange) {
  return useQuery({
    queryKey: ['miniapp', 'analytics', range],
    queryFn: () => fetchAnalytics(range),
    staleTime: 60 * 1000,
  });
}
